import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "./baseQuery";
import { IPracticeInfo } from "../types/landingPage/IPracticeInfo.interface";

export const landingPageApi = createApi({
  reducerPath: "landingPageApi",
  baseQuery: baseQueryWithReauth(
    `${import.meta.env.VITE_APP_YAPI_DOCMGR}api/v1`
  ),
  endpoints: (builder) => ({
    getPracticesInfo: builder.query<IPracticeInfo, string>({
      query: (practiceId) => `/practices/${practiceId}`,
    }),
  }),
});

export const { useGetPracticesInfoQuery } = landingPageApi;
